import React, { useState } from "react";
import styles from "./Projects.module.css";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, EffectCoverflow, Pagination } from "swiper";
import {
  project1,
  project2,
  project3,
  project4,
  project5,
  project6,
  project7,
} from "../../assets";
import { useMediaQuery } from "react-responsive";

const Projects = () => {
  const isMobile = useMediaQuery({
    query: "(max-width: 855px)",
  });

  return (
    <section id="projects" className={styles.container}>
      <div className={styles.projects}>
        <h1>Recent Projects</h1>
        <p>
          These were some of the projects which I worked in the last 6 months. I
          worked both in Fullstack Web Applications and Mobiles Applications.
        </p>
      </div>
      {isMobile ? (
        <Swiper
          effect={"cards"}
          grabCursor={true}
          modules={[EffectCards]}
          className={styles.project__swiper}
          initialSlide={1}
        >
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project1} alt="" />
            <h3>E-Learning Platform</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Node.js, MongoDB, AWS
              and Razorpay
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project2} alt="" />
            <h3>Netflix Clone</h3>
            <p>
              <strong>Techs Used:</strong> React, Redux, Firebase and Stripe
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project3} alt="" />
            <h3>Edtech Website</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Node.js, MongoDB,
              OAuth and AWS
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project4} alt="" />
            <h3>Medium Clone</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Typescript, Sanity.io
              and Tailwindcss
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project5} alt="" />
            <h3>Anonymous Talk App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative, Node.js, Socket.io,
              Sqlite and Firebase
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project6} alt="" />
            <h3>Prapatti App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative and Native Music Lib
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project7} alt="" />
            <h3>Quizzles App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative
            </p>
          </SwiperSlide>
        </Swiper>
      ) : (
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className={styles.project__swiper}
          initialSlide={1}
        >
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project1} alt="" />
            <h3>E-Learning Platform</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Node.js, MongoDB, AWS
              and Razorpay
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project2} alt="" />
            <h3>Netflix Clone</h3>
            <p>
              <strong>Techs Used:</strong> React, Redux, Firebase and Stripe
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project3} alt="" />
            <h3>Edtech Website</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Node.js, MongoDB,
              OAuth and AWS
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project4} alt="" />
            <h3>Medium Clone</h3>
            <p>
              <strong>Techs Used:</strong> React, Next.js, Typescript, Sanity.io
              and Tailwindcss
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project5} alt="" />
            <h3>Anonymous Talk App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative, Node.js, Socket.io,
              Sqlite and Firebase
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project6} alt="" />
            <h3>Prapatti App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative and Native Music Lib
            </p>
          </SwiperSlide>
          <SwiperSlide className={styles.swiper__slide}>
            <img src={project7} alt="" />
            <h3>Quizzles App</h3>
            <p>
              <strong>Techs Used:</strong> ReactNative
            </p>
          </SwiperSlide>
        </Swiper>
      )}
    </section>
  );
};

export default Projects;
